import { supabase } from "./supabase";

export type PublicPayoutReceipt = {
  id: string;
  amountUsd: number;
  paidAt: string;
  method: string;
};

type PublicPayoutRow = {
  receipt_id: string;
  amount_usd: number | string;
  paid_at: string;
  method: string;
};

export async function getPublicPayoutReceipts(): Promise<PublicPayoutReceipt[]> {
  if (!supabase) return [];

  const { data, error } = await supabase.rpc("get_public_payout_receipts", { p_limit: 24 });
  if (error) {
    console.error("Unable to load public payout receipts.", error);
    return [];
  }

  return ((data ?? []) as PublicPayoutRow[]).map((row) => ({
    id: row.receipt_id,
    amountUsd: Number(row.amount_usd),
    paidAt: row.paid_at,
    method: row.method.toUpperCase().replace("_", " "),
  }));
}
